import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="10" y="15" rx="1" ry="1" width="10" height="10" />
      <rect x="30" y="16" rx="2" ry="2" width="50" height="166" />
      <rect x="100" y="16" rx="2" ry="2" width="60" height="5" />
      <rect x="100" y="30" rx="2" ry="2" width="150" height="10" />
      <rect x="100" y="45" rx="2" ry="2" width="118" height="4" />
      <rect x="340" y="13" rx="2" ry="2" width="50" height="14" />
      <rect x="290" y="14" rx="2" ry="2" width="43" height="4" />
      <rect x="303" y="20" rx="2" ry="2" width="30" height="4" />
      <rect x="307" y="27" rx="2" ry="2" width="26" height="3" />
      <rect x="100" y="60" rx="2" ry="2" width="222" height="4" />
      <rect x="100" y="70" rx="2" ry="2" width="290" height="30" />
    </React.Fragment>
  );
};
